import React from 'react';
import './Skills.css';

/**
 * Get color class based on proficiency level
 */
function getLevelColor(level) {
  if (level >= 80) return 'expert';     // Green for expert
  if (level >= 40) return 'intermediate'; // Yellow/orange for intermediate
  return 'learning';                     // Light blue for learning
}

/**
 * Skills section with progress bar visualization
 */
export default function Skills({ skills, title = 'Skills' }) {
  if (!skills || !Array.isArray(skills)) {
    return null;
  }

  // Group by category
  const grouped = {};
  skills.forEach(skill => {
    const cat = skill.category || 'General';
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(skill);
  });

  return (
    <section className="section" id="skills" aria-labelledby="skills-heading">
      <h3 id="skills-heading">{title}</h3>
      
      {Object.entries(grouped).sort((a, b) => a[0].localeCompare(b[0])).map(([category, categorySkills]) => (
        <div key={category} className="skill-category">
          <h4 className="skill-category-title">{category}</h4>
          <div className="skills-list" role="list" aria-label={`${category} skills`}>
            {categorySkills.map((skill, index) => {
              const colorClass = getLevelColor(skill.level);
              return (
                <div key={index} className="skill-item" role="listitem">
                  <span className="skill-name">{skill.name}</span>
                  <div 
                    className={`skill-bar ${colorClass}`}
                    role="meter"
                    aria-valuenow={skill.level}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label={`${skill.name}: ${skill.level}%`}
                    style={{ '--bar-width': `${skill.level}%` }}
                  />
                  <span className="skill-level" aria-hidden="true">{skill.level}%</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
